export const modalMixin = {
    methods: {
        /**
         * Return promise object with boolean value
         *
         * @param message
         * @returns {Promise<BvMsgBoxData>}
         */
        confirmAction(message) {
            return this.$bvModal.msgBoxConfirm(message, {
                title: '',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Yes',
                cancelTitle: 'No',
                footerClass: 'p-2',
                hideHeaderClose: false,
            });
        },
    },
};
